import { useEffect, useState } from 'react'
import translate from '../../core/translate'
import {
    ExternalAdvertisementSelectedItem,
    ExternalAdvertisementTabId,
    IExternalAdvertisementHooksResult,
    IExternalAdvertisementTab,
    IExternalAdvertisementDevice,
} from './externalAdvertisement.types'
import { api } from '../../core/api/ConnectionManager'

export const ExternalAdvertisementHooks = (): IExternalAdvertisementHooksResult => {
    const [selectedTab, setSelectedTab] = useState<ExternalAdvertisementTabId>('devices')
    const [selectedInfo, setSelectedInfo] = useState<ExternalAdvertisementSelectedItem>(null)
    const [selectedItems, setSelectedItems] = useState<IExternalAdvertisementDevice[]>([])
    const [moderationCount, setModerationCount] = useState<number>(0)
    const tabList: IExternalAdvertisementTab[] = [
        {
            id: 'devices',
            label: translate('devices'),
        },
        {
            id: 'advertisementDevices',
            label: translate('advertisementDevices'),
        },
        {
            id: 'contentModeration',
            label: `${translate('contentModerationTitle')}${moderationCount > 0 ? ` (+${moderationCount})` : ''}`,
        },
    ]

    useEffect(() => {
        setSelectedInfo(null)
        setSelectedItems([])

        api.send('getPendingCreativesCount', {}).then((res: any) => {
            if (res && res.pendingCount) {
                setModerationCount(res.pendingCount)
            }
        })
    }, [selectedTab])

    return {
        selectedTab,
        setSelectedTab,
        tabList,
        selectedInfo,
        setSelectedInfo,
        selectedItems,
        setSelectedItems,
        moderationCount,
        setModerationCount,
    }
}
